import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { BnToastrComponent } from '@bn/web-ui/toastr/components/bn-toastr/bn-toastr.component';

@Component({
  selector: 'bn-partner-portal-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [BnToastrComponent, RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {}
